export function updateModel(
  sceneModel: any,
  options: {
    position?: (number | null | undefined)[];
    rotation?: (number | null | undefined)[];
    scale?: (number | null | undefined)[];
  },
) {
  if (options?.position) sceneModel.position = options.position;
  //if (options?.rotation) sceneModel.rotation = options.rotation;
  //if (options?.scale) sceneModel.scale = options.scale;
}
